/**
 * Product Description Accordion
 * Başlıkları accordion yapısına dönüştürür
 * H2, strong veya bilinen başlık metinlerini destekler
 */
(function() {
  'use strict';

  // Bilinen bölüm başlıkları (büyük/küçük harf duyarsız)
  var knownSectionTitles = [
    'İÇERİĞİNDEKİ BİTKİLER',
    'IÇERIGINDEKI BITKILER',
    'AÇIKLAMA',
    'ACIKLAMA',
    'SAĞLIK BEYANLARI',
    'SAGLIK BEYANLARI',
    'YASAL UYARILAR',
    'KULLANIM ŞEKLİ',
    'KULLANIM SEKLI',
    'İÇİNDEKİLER',
    'ICINDEKILERI',
    'UYARILAR',
    'ÖNERİLEN KULLANIM',
    'ONERILEN KULLANIM',
    'SAKLANIM KOŞULLARI',
    'SAKLAMA KOŞULLARI'
  ];

  function normalizeText(text) {
    return text.trim().toUpperCase()
      .replace(/İ/g, 'I')
      .replace(/Ğ/g, 'G')
      .replace(/Ü/g, 'U')
      .replace(/Ş/g, 'S')
      .replace(/Ö/g, 'O')
      .replace(/Ç/g, 'C');
  }

  function isSectionTitle(text) {
    var normalized = normalizeText(text);
    for (var i = 0; i < knownSectionTitles.length; i++) {
      var normalizedTitle = normalizeText(knownSectionTitles[i]);
      if (normalized === normalizedTitle || normalized.indexOf(normalizedTitle) !== -1) {
        return true;
      }
    }
    // Ayrıca tamamen büyük harfli ve 3+ kelimeden oluşan metinleri de kontrol et
    if (text === text.toUpperCase() && text.length > 5 && text.length < 50) {
      return true;
    }
    return false;
  }

  function findHeadingElements(container) {
    var headings = [];

    // Debug: İçeriği logla
    console.log('Accordion: Container içeriği analiz ediliyor...');
    console.log('Accordion: HTML önizleme:', container.innerHTML.substring(0, 500));

    // Önce H2 etiketlerini kontrol et
    var h2Elements = container.querySelectorAll('h2');
    if (h2Elements.length > 0) {
      console.log('Accordion: ' + h2Elements.length + ' H2 elementi bulundu');
      h2Elements.forEach(function(el) {
        headings.push({ element: el, title: el.textContent.trim(), type: 'h2' });
      });
      return headings;
    }

    // H3, H4, H5, H6 etiketlerini de kontrol et
    var otherHeadings = container.querySelectorAll('h3, h4, h5, h6');
    if (otherHeadings.length > 0) {
      console.log('Accordion: ' + otherHeadings.length + ' diğer heading elementi bulundu');
      otherHeadings.forEach(function(el) {
        var text = el.textContent.trim();
        if (isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'heading' });
        }
      });
      if (headings.length > 0) return headings;
    }

    // Strong/b etiketlerini kontrol et - daha geniş arama
    var allElements = container.querySelectorAll('p, strong, b, span');

    allElements.forEach(function(el) {
      var text = el.textContent.trim();

      // P elementi ise, içinde sadece strong/b var mı kontrol et
      if (el.tagName === 'P') {
        var children = el.children;
        // Sadece strong/b içeren p
        if (children.length === 1 && (children[0].tagName === 'STRONG' || children[0].tagName === 'B')) {
          var strongText = children[0].textContent.trim();
          if (isSectionTitle(strongText)) {
            headings.push({ element: el, title: strongText, type: 'p-strong' });
          }
        }
        // Veya strong içeren kısa p (başlık gibi)
        else if (children.length >= 1) {
          var firstChild = children[0];
          if ((firstChild.tagName === 'STRONG' || firstChild.tagName === 'B') &&
              firstChild.textContent.trim() === text && isSectionTitle(text)) {
            headings.push({ element: el, title: text, type: 'p-strong' });
          }
        }
        // P'nin kendisi tamamen büyük harfli bir başlık mı?
        else if (el.children.length === 0 && isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'p-text' });
        }
      }
      // Direkt strong/b elementi
      else if ((el.tagName === 'STRONG' || el.tagName === 'B')) {
        // Parent'ı p ise ve p'nin tek çocuğu ise zaten yakalandı
        var parent = el.parentElement;
        if (parent && parent.tagName === 'P' && parent.children.length === 1) {
          // Zaten yakalandı, geç
        } else if (isSectionTitle(text)) {
          // Parent p değilse veya başka kardeşleri varsa
          headings.push({ element: el, title: text, type: 'strong' });
        }
      }
      // Span elementi - bazen başlıklar span içinde olabilir
      else if (el.tagName === 'SPAN') {
        var style = window.getComputedStyle(el);
        var isBold = style.fontWeight === 'bold' || parseInt(style.fontWeight) >= 600;
        if (isBold && isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'span' });
        }
      }
    });

    console.log('Accordion: Toplam ' + headings.length + ' başlık bulundu');
    if (headings.length > 0) {
      headings.forEach(function(h, i) {
        console.log('Accordion: Başlık ' + (i+1) + ': "' + h.title + '" (tip: ' + h.type + ')');
      });
    }

    return headings;
  }

  function initDescriptionAccordion() {
    var containers = document.querySelectorAll('.product-description-accordion__content, [data-description-accordion]');

    containers.forEach(function(container) {
      // Zaten dönüştürülmüş mü kontrol et
      if (container.dataset.accordionInitialized) return;
      container.dataset.accordionInitialized = 'true';

      // Başlıkları bul
      var headingData = findHeadingElements(container);
      if (headingData.length === 0) {
        console.log('Accordion: Başlık bulunamadı');
        return;
      }

      console.log('Accordion: ' + headingData.length + ' başlık bulundu', headingData);

      // Accordion wrapper oluştur
      var accordionWrapper = document.createElement('div');
      accordionWrapper.className = 'product-description-accordions';

      // Tüm içeriği geçici olarak sakla
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = container.innerHTML;

      // Başlık elementlerinin orijinal DOM referanslarını yeniden bul
      var headingElements = [];
      headingData.forEach(function(h) {
        var selector = h.type === 'h2' ? 'h2' : (h.type === 'p-strong' || h.type === 'p-text' ? 'p' : 'strong, b');
        tempDiv.querySelectorAll(selector).forEach(function(el) {
          if (el.textContent.trim() === h.title || el.textContent.trim().indexOf(h.title) !== -1) {
            if (headingElements.indexOf(el) === -1) {
              headingElements.push(el);
            }
          }
        });
      });

      // İlk başlıktan önce gelen içerik için
      var beforeFirstHeading = document.createDocumentFragment();
      var foundFirstHeading = false;

      // Sections oluştur
      var sections = [];
      var currentSection = null;

      // headingData'nın bir kopyasını oluştur
      var remainingHeadings = headingData.slice();

      // Tüm child node'ları işle
      Array.from(tempDiv.childNodes).forEach(function(node) {
        var isHeading = false;
        var headingTitle = '';

        // Bu node bir başlık mı kontrol et
        if (node.nodeType === 1) {
          var nodeText = node.textContent.trim();

          for (var i = 0; i < remainingHeadings.length; i++) {
            var h = remainingHeadings[i];

            // Metin eşleşmesi kontrol et
            var textMatch = nodeText === h.title ||
                (nodeText.indexOf(h.title) !== -1 && nodeText.length < h.title.length + 20);

            if (textMatch) {
              // Element tipi kontrolü
              var typeMatch = false;

              if (h.type === 'h2' && node.tagName === 'H2') typeMatch = true;
              else if (h.type === 'heading' && /^H[3-6]$/.test(node.tagName)) typeMatch = true;
              else if ((h.type === 'p-strong' || h.type === 'p-text') && node.tagName === 'P') typeMatch = true;
              else if (h.type === 'strong' && (node.tagName === 'STRONG' || node.tagName === 'B')) typeMatch = true;
              else if (h.type === 'span' && node.tagName === 'SPAN') typeMatch = true;

              if (typeMatch) {
                isHeading = true;
                headingTitle = h.title;
                // Bu başlığı listeden çıkar ki tekrar kullanılmasın
                remainingHeadings.splice(i, 1);
                console.log('Accordion: Başlık işleniyor: "' + headingTitle + '"');
                break;
              }
            }
          }
        }

        if (isHeading) {
          foundFirstHeading = true;
          // Yeni section başlat
          currentSection = {
            title: headingTitle,
            content: document.createDocumentFragment()
          };
          sections.push(currentSection);
        } else if (currentSection) {
          // Mevcut section'a ekle
          currentSection.content.appendChild(node.cloneNode(true));
        } else if (!foundFirstHeading) {
          // Başlıktan önce gelen içerik
          beforeFirstHeading.appendChild(node.cloneNode(true));
        }
      });

      // Accordion item'ları oluştur
      sections.forEach(function(section, index) {
        var details = document.createElement('details');
        details.className = 'product-desc-accordion';

        // İlk accordion'u aç
        if (index === 0) {
          details.setAttribute('open', '');
        }

        var summary = document.createElement('summary');
        summary.className = 'product-desc-accordion__summary';
        summary.innerHTML =
          '<span class="product-desc-accordion__title">' + section.title + '</span>' +
          '<span class="product-desc-accordion__icon">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</span>';

        var content = document.createElement('div');
        content.className = 'product-desc-accordion__content rte text-subtext';
        content.appendChild(section.content);

        details.appendChild(summary);
        details.appendChild(content);
        accordionWrapper.appendChild(details);
      });

      // Orijinal içeriği temizle
      container.innerHTML = '';

      // Başlıktan önce gelen içeriği ekle
      if (beforeFirstHeading.childNodes.length > 0) {
        var beforeContent = document.createElement('div');
        beforeContent.className = 'product-desc-before-accordion';
        beforeContent.appendChild(beforeFirstHeading);
        container.appendChild(beforeContent);
      }

      // Accordion wrapper'ı ekle
      if (sections.length > 0) {
        container.appendChild(accordionWrapper);
        console.log('Accordion: ' + sections.length + ' bölüm oluşturuldu');
      }
    });
  }

  // Global erişim için
  window.initDescriptionAccordion = initDescriptionAccordion;

  // DOM hazır olduğunda çalıştır
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('Accordion: DOMContentLoaded - başlatılıyor');
      initDescriptionAccordion();
    });
  } else {
    console.log('Accordion: DOM hazır - hemen başlatılıyor');
    initDescriptionAccordion();
  }

  // Shopify section render event'i için
  document.addEventListener('shopify:section:load', function() {
    console.log('Accordion: shopify:section:load - yeniden başlatılıyor');
    initDescriptionAccordion();
  });

  // MutationObserver ile dinamik içerik değişikliklerini izle
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var accordionContainers = node.querySelectorAll ?
              node.querySelectorAll('.product-description-accordion__content, [data-description-accordion]') : [];
            if (accordionContainers.length > 0 ||
                (node.classList && (node.classList.contains('product-description-accordion__content') ||
                 node.hasAttribute && node.hasAttribute('data-description-accordion')))) {
              setTimeout(initDescriptionAccordion, 100);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
